import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { ContentService } from '../content.service';

// While the content package has no post, /blog matches nothing and falls through to the home page.
export const hasBlogGuard: CanMatchFn = () =>
  inject(ContentService).site().pipe(
    map(site => site.hasBlog),
    catchError(() => of(false)),
  );
